import { useCallback } from 'react';

const CONTEXT_KEY = 'sc_context';
const BITRIX24_CONTEXT = 'bitrix24';

/** Non-hook check — usable in authStore, AuthGuard, etc. */
export function isBitrix24Context(): boolean {
  return (
    localStorage.getItem(CONTEXT_KEY) === BITRIX24_CONTEXT && typeof window.BX24 !== 'undefined'
  );
}

export function clearBitrix24Context(): void {
  localStorage.removeItem(CONTEXT_KEY);
}

export function useBitrix24() {
  const isBitrix24 = isBitrix24Context();

  const fitWindow = useCallback(() => {
    if (window.BX24) {
      window.BX24.fitWindow();
    }
  }, []);

  const refreshBitrixAuth = useCallback((): Promise<BX24Auth | null> => {
    return new Promise((resolve) => {
      if (!window.BX24) {
        resolve(null);
        return;
      }
      window.BX24.refreshAuth((auth) => resolve(auth?.access_token ? auth : null));
    });
  }, []);

  return { isBitrix24, fitWindow, refreshBitrixAuth };
}
